/** Cross-component signal to refetch merged catalog (shop + server uploads). */
export const CATALOG_UPDATED_EVENT = "lfx-catalog-updated";

export function notifyCatalogUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CATALOG_UPDATED_EVENT));
  }
}
